// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "8px";
var _5 = "6px";
var _6 = "8px";
var _7 = "bottomMenu___D_7OZ";
var _8 = "bottomMenuContainer___An_nv";
var _9 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _a = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _b = "brandLogoRow___z5YHU";
var _c = "brandLogoRowCollapsed___Torca";
var _d = "brandingContainer___NtGMp";
var _e = "10px";
var _f = "#e8e8e8";
var _10 = "16px 24px";
var _11 = "#38aa73";
var _12 = "#956c22";
var _13 = "#2988bd";
var _14 = "#eee";
var _15 = "cobaltLogoExpanded___fxh1T";
var _16 = "#c4842d";
var _17 = "#b8567c";
var _18 = "#8b6e4e";
var _19 = "#5889c2";
var _1a = "#4e8a8a";
var _1b = "#6a8a3e";
var _1c = "#7b5ea7";
var _1d = "#4a6fa5";
var _1e = "#3a8a6e";
var _1f = "#c25b4e";
var _20 = "#fafbfc";
var _21 = "#1e3050";
var _22 = "#293d62";
var _23 = "#fafbfc";
var _24 = "rgba(0,0,0,.12)";
var _25 = "#d9d9d9";
var _26 = "rgba(5,5,5,.1)";
var _27 = "#eaf2fc";
var _28 = "rgba(0,0,0,.65)";
var _29 = "#ebebeb";
var _2a = "#068467";
var _2b = "rgba(6,132,103,.1)";
var _2c = "#dc4949";
var _2d = "rgba(220,73,73,.1)";
var _2e = "#787c81";
var _2f = "#d6d9dc";
var _30 = "#f3f5f7";
var _31 = "#73c9b2";
var _32 = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _33 = "#b8e7da";
var _34 = "#5357f8";
var _35 = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _36 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _37 = "#f7f8f9";
var _38 = "#edeeef";
var _39 = "#7b8996";
var _3a = "#ededed";
var _3b = "#f4f5f7";
var _3c = "#fbfbfc";
var _3d = "rgba(0,0,0,.75)";
var _3e = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _3f = "rgba(0,0,0,.3)";
var _40 = "rgba(0,0,0,.5)";
var _41 = "rgba(0,0,0,.4)";
var _42 = "rgba(0,0,0,.95)";
var _43 = "rgba(0,0,0,.65)";
var _44 = "rgba(0,0,0,.85)";
var _45 = "20px";
var _46 = "#f41e28";
var _47 = "1063px";
var _48 = "divider___cYsNn";
var _49 = "dividerFullWidth___YnxRd";
var _4a = "rgba(227,89,86,.2)";
var _4b = "#e35956";
var _4c = "16px 24px";
var _4d = "28px";
var _4e = "32px";
var _4f = "18px";
var _50 = "14px";
var _51 = "14px";
var _52 = "15px";
var _53 = "12.6px";
var _54 = "11px";
var _55 = "20px";
var _56 = "28px";
var _57 = "700";
var _58 = "200";
var _59 = "300";
var _5a = "500";
var _5b = "400";
var _5c = "600";
var _5d = "forgeSideMenu___J_zMf";
var _5e = "forgeSideMenuFooter___oXquj";
var _5f = "hsla(0,0%,100%,.2)";
var _60 = "#ccc";
var _61 = "49px";
var _62 = "5px";
var _63 = "#5357f8";
var _64 = "rgba(0,0,0,.4)";
var _65 = "mainNavWrapper___DzeNx";
var _66 = "navExpandIcon___BaUNJ";
var _67 = "navExpandIconClosed___rmBHV";
var _68 = "navExpandIconOpen___eIkaM";
var _69 = "navLabelText___gPRx8";
var _6a = "#fafafa";
var _6b = "hsla(0,0%,100%,.9)";
var _6c = "15px";
var _6d = "20px";
var _6e = "24px";
var _6f = "sectionDivider___R9FqM";
var _70 = "sectionDividerCollapsed___UvqSQ";
var _71 = "hsla(0,0%,100%,.6)";
var _72 = "#7e7eff";
var _73 = "hsla(0,0%,100%,.7)";
var _74 = "hsla(0,0%,100%,.3)";
var _75 = "hsla(0,0%,100%,.575)";
var _76 = "60px";
var _77 = "208px";
var _78 = "siderWrapper___EehAK";
var _79 = "rgba(82,196,26,.2)";
var _7a = "#52c41a";
var _7b = "12px";
var _7c = "20px";
var _7d = "toggleSidebarButton___ck6Y3";
var _7e = "toggleSidebarButtonCollapsed___rf3Bm";
var _7f = "toggleSidebarButtonExpanded___vipG8";
var _80 = "rgba(250,173,20,.2)";
var _81 = "#faad14";
var _82 = "#fff";
var _83 = "hsla(0,0%,100%,.2)";
var _84 = "whitelabelLogoContainer___XQGLg";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "borderRadiusCard", _5 as "borderRadiusMain", _6 as "borderRadiusSurface", _7 as "bottomMenu", _8 as "bottomMenuContainer", _9 as "boxShadowInnerXs", _a as "boxShadowXl", _b as "brandLogoRow", _c as "brandLogoRowCollapsed", _d as "brandingContainer", _e as "btnRightMargin", _f as "cardBorderColor", _10 as "cardPadding", _11 as "changeSetCompletedColor", _12 as "changeSetManuallyChangesProposed", _13 as "changeSetScheduledChangesProposed", _14 as "chipBackground", _15 as "cobaltLogoExpanded", _16 as "colorAccentAmber", _17 as "colorAccentBerry", _18 as "colorAccentBrown", _19 as "colorAccentCornflower", _1a as "colorAccentCyan", _1b as "colorAccentOlive", _1c as "colorAccentPurple", _1d as "colorAccentSteelBlue", _1e as "colorAccentTeal", _1f as "colorAccentTerracotta", _20 as "colorBackgroundMain", _21 as "colorBackgroundSidebar", _22 as "colorBackgroundSidebarHover", _23 as "colorBackgroundTabs", _24 as "colorBorderContainer", _25 as "colorBorderMain", _26 as "colorBorderSecondary", _27 as "colorDeltaCyanBlueBg", _28 as "colorDeltaGray", _29 as "colorDeltaGrayBg", _2a as "colorDeltaGreen", _2b as "colorDeltaGreenBg", _2c as "colorDeltaRed", _2d as "colorDeltaRedBg", _2e as "colorDetailsFieldText", _2f as "colorDetailsIcon", _30 as "colorDetailsTagBg", _31 as "colorMint", _32 as "colorMintGradient", _33 as "colorMintLight", _34 as "colorPrimary", _35 as "colorPrimaryHover", _36 as "colorPrimaryLightened", _37 as "colorTableHeadBg", _38 as "colorTableHeadBgHover", _39 as "colorTableHeadSubtitle", _3a as "colorTableRowBorder", _3b as "colorTableTextBg", _3c as "colorTableTotalRowBg", _3d as "colorTextBase", _3e as "colorTextDisabled", _3f as "colorTextExtraLight", _40 as "colorTextLight", _41 as "colorTextLighter", _42 as "colorTextMainHeading", _43 as "colorTextMuted", _44 as "colorTextPrimary", _45 as "contentHorizPadding", _46 as "dangerColor", _47 as "dashboardPdfContentWidth", _48 as "divider", _49 as "dividerFullWidth", _4a as "errorBackcolor", _4b as "errorColor", _4c as "filterPanelPadding", _4d as "filtersDefaultHeight", _4e as "filtersTallHeight", _4f as "fontSizeLarge", _50 as "fontSizeMain", _51 as "fontSizeMedium", _52 as "fontSizePlus", _53 as "fontSizeSmaller", _54 as "fontSizeSmallest", _55 as "fontSizeXLarge", _56 as "fontSizeXxLarge", _57 as "fontWeightBold", _58 as "fontWeightExtraLight", _59 as "fontWeightLight", _5a as "fontWeightMediumBold", _5b as "fontWeightNormal", _5c as "fontWeightSemiBold", _5d as "forgeSideMenu", _5e as "forgeSideMenuFooter", _5f as "ghostWhite", _60 as "grayBackgroundColor", _61 as "headerHeight", _62 as "iconHorizontalMargin", _63 as "linkColor", _64 as "linkColorMuted", _65 as "mainNavWrapper", _66 as "navExpandIcon", _67 as "navExpandIconClosed", _68 as "navExpandIconOpen", _69 as "navLabelText", _6a as "popoverHeaderColor", _6b as "popoverMaskColor", _6c as "rowPadding", _6d as "ruleInnerGutters", _6e as "ruleSideGutters", _6f as "sectionDivider", _70 as "sectionDividerCollapsed", _71 as "sideMenuIconColor", _72 as "sideMenuIconSelectedColor", _73 as "sideMenuItemColor", _74 as "sideMenuScrollbarThumbColor", _75 as "sideMenuSubmenuItemColor", _76 as "sidebarCollapsedWidth", _77 as "sidebarWidth", _78 as "siderWrapper", _79 as "successBackcolor", _7a as "successColor", _7b as "tableHeaderVerticalPadding", _7c as "tableHorizPadding", _7d as "toggleSidebarButton", _7e as "toggleSidebarButtonCollapsed", _7f as "toggleSidebarButtonExpanded", _80 as "warningBackcolor", _81 as "warningColor", _82 as "whiteColor", _83 as "whiteDividerColor", _84 as "whitelabelLogoContainer" }
